export default "__VITE_ASSET__Cb5BexD0__"